import React from 'react';
import Cookies from 'universal-cookie';

import {
  listen,
  broadcast,
  post_gql,
  polygon_layer,
  text_layer,
  marker_layer,
  video_layer,
  chat_layer,
  IS_DEV
} from './utils'

import {line_layer, line_distance_layer} from './utils/line_utils'

import MyMap from './Map';

import { Socket as PhoenixSocket} from 'phoenix'
import Toolbar from './components/toolbar';
import Auth from './components/auth';
import PolygonTool from './components/polygon_tool';
import LineTool from './components/line_tool';
import TextTool from './components/text_tool';
import PointTool from './components/point_tool';
import TilesTool from './components/tiles_tool';
import VideoTool from './components/video_tool';
import Chat from './components/chat';
import Notifications from './components/notifications';
import UserLayers from './components/user_layers';
import LayerEditor from './components/layer_editor';

const reload_if_no_token = (id, access_token) => {
  var token = window.location.pathname.replace("/t/", "")
  const origin = window.location.origin.replace("3000", "4000")

  const cookies = new Cookies()
  const map_token = cookies.get('map_token')

  if (token === "" || token === "/") {
    if (map_token){
      window.location.replace(`${window.location.origin}/t/${map_token}`)
    } else {
      post_gql(
        "mutation {geomapCreate { token }}",
        resp => window.location.replace(`${window.location.origin}/t/${resp.data.data.geomapCreate.token}`)
      )
    }
  } else {
    if (token === "" || token === "/")
      token = map_token

    cookies.set('map_token', token, { path: '/' });

    post_gql(
      `mutation {geomapUserJoin(map_token: "${token}"){
        geomap {tile_links {title styles_json_url selected}}
        users {id name picture}
        settings
        notifications {
          chat_id new_messages_count coords user_name
          title picture last_m_time first_m_time
        }
      }}`,
      resp => {
        resp = resp.data.data.geomapUserJoin
        broadcast("set_view_state", {...resp.settings.view_state, id: id})
        broadcast("set_polygon_settings", {...resp.settings.polygon_settings, id: id})
        broadcast("set_line_settings", {...resp.settings.line_settings, id: id})
        broadcast("set_text_settings", {...resp.settings.text_settings, id: id})
        broadcast("set_point_settings", {...resp.settings.point_settings, id: id})
        broadcast("set_video_settings", {...resp.settings.video_settings, id: id})
        broadcast("set_settings", resp.settings)
        broadcast("notifications", resp.notifications)

        resp.users.forEach(u => broadcast("user_online_socket", u))
        broadcast("map_tile_links", resp.geomap.tile_links)
      },
      {"authorization": `Bearer ${access_token}`}
    )

    post_gql(
      `query {geomapLayerGetByMap(geomap_id: "${token}"){
          id user_id point_coords coords line_coords coords_multi type
          polygon_settings { color radius opacity border_color border_width border_opacity pattern pattern_scale}
          line_settings { color width opacity cap_rounded joint_rounded show_points show_distance}
          text_settings {
            color opacity text size anchor alignment_baseline angle font_family font_weight max_width word_break
            background_padding_left background_padding_right background_padding_top background_padding_bottom
            background_color background_opacity border_color border_opacity border_width
            outline_color outline_opacity outline_width
          }
          video_settings {url coord1 coord2 coord3 coord4 min_zoom max_zoom}
          point_settings { icon_atlas icon_mapping icon size angle min_pixels max_pixels tooltip_text }
          chat_settings {title picture status created_at}
      }}`,
      resp => resp.data.data.geomapLayerGetByMap.forEach(props => {

        switch (props.type) {
          case "TEXT":
            broadcast("add_or_replace_layer", text_layer(props.point_coords, props))
            break;
          case "POINT":
            broadcast("add_or_replace_layer", marker_layer(props.point_coords, props))
            break;

          case "LINE":
            broadcast("add_or_replace_layer", line_layer(props))
            if (props.line_settings.show_distance)
              broadcast("add_or_replace_layer", line_distance_layer(`${props.id}_distance`, props.line_coords))
            break;

          case "CHAT":
            chat_layer(props.point_coords, props).forEach(l => broadcast("add_or_replace_layer", l))
            break;

          case "VIDEO":
            broadcast("add_or_replace_layer", video_layer(props))
            break;

          default:
            broadcast("add_or_replace_layer", polygon_layer(props, props.coords.length === 0 ? "MultiPolygon" : "Polygon"))
        }
      })
    )

    var socket_url = `ws://back.${origin.replace("http://", "")}/api/socket`

    if (IS_DEV)
      socket_url = `ws://${origin.replace("http://", "")}/api/socket`

    const socket = new PhoenixSocket(socket_url, {params: {token: access_token}})
    socket.connect()
    const channel = socket.channel(`user:${id}`, {})
    channel.join()

    channel.on('notifications', resp => broadcast('notifications', resp.notifications))
    channel.on('map_tile_links', resp => broadcast('map_tile_links', resp.tile_links))
    channel.on('user_online', resp => broadcast('user_online_socket', resp))
    channel.on('user_offline', resp => broadcast('user_offline_socket', resp))
    channel.on('user_map_hover', resp => broadcast('user_map_hover', resp))
    channel.on('user_map_drag_start', resp => broadcast('user_map_drag_start', resp))
    channel.on('user_map_drag_end', resp => broadcast('user_map_drag_end', resp))
    channel.on('user_map_drag', resp => broadcast('user_map_drag', resp))
    channel.on('polygon_color', resp => broadcast('polygon_color', resp))
    channel.on('polygon_radius', resp => broadcast('polygon_radius', resp))
    channel.on('polygon_opacity', resp => broadcast('polygon_opacity', resp))
    channel.on('polygon_border_width', resp => broadcast('polygon_border_width', resp))
    channel.on('polygon_border_opacity', resp => broadcast('polygon_border_opacity', resp))
    channel.on('polygon_border_color', resp => broadcast('polygon_border_color', resp))
    channel.on('polygon_pattern', resp => broadcast('polygon_pattern', resp))
    channel.on('polygon_pattern_scale', resp => broadcast('polygon_pattern_scale', resp))

    channel.on('text_color', resp => broadcast('text_color', resp))
    channel.on('text_opacity', resp => broadcast('text_opacity', resp))
    channel.on('text_text', resp => broadcast('text_text', resp))
    channel.on('text_size', resp => broadcast('text_size', resp))
    channel.on('text_anchor', resp => broadcast('text_anchor', resp))
    channel.on('text_alignment_baseline', resp => broadcast('text_alignment_baseline', resp))
    channel.on('text_angle', resp => broadcast('text_angle', resp))
    channel.on('text_font_family', resp => broadcast('text_font_family', resp))
    channel.on('text_font_weight', resp => broadcast('text_font_weight', resp))
    channel.on('text_max_width', resp => broadcast('text_max_width', resp))
    channel.on('text_word_break', resp => broadcast('text_word_break', resp))
    channel.on('text_background_padding_left', resp => broadcast('text_background_padding_left', resp))
    channel.on('text_background_padding_right', resp => broadcast('text_background_padding_right', resp))
    channel.on('text_background_padding_top', resp => broadcast('text_background_padding_top', resp))
    channel.on('text_background_padding_bottom', resp => broadcast('text_background_padding_bottom', resp))
    channel.on('text_background_color', resp => broadcast('text_background_color', resp))
    channel.on('text_background_opacity', resp => broadcast('text_background_opacity', resp))
    channel.on('text_border_color', resp => broadcast('text_border_color', resp))
    channel.on('text_border_opacity', resp => broadcast('text_border_opacity', resp))
    channel.on('text_border_width', resp => broadcast('text_border_width', resp))
    channel.on('text_outline_color', resp => broadcast('text_outline_color', resp))
    channel.on('text_outline_opacity', resp => broadcast('text_outline_opacity', resp))
    channel.on('text_outline_width', resp => broadcast('text_outline_width', resp))

    channel.on('point_icon', resp => broadcast('point_icon', resp))
    channel.on('point_size', resp => broadcast('point_size', resp))
    channel.on('point_angle', resp => broadcast('point_angle', resp))
    channel.on('point_min_pixels', resp => broadcast('point_min_pixels', resp))
    channel.on('point_max_pixels', resp => broadcast('point_max_pixels', resp))
    channel.on('point_tooltip_text', resp => broadcast('point_tooltip_text', resp))

    channel.on('line_color', resp => broadcast('line_color', resp))
    channel.on('line_opacity', resp => broadcast('line_opacity', resp))
    channel.on('line_width', resp => broadcast('line_width', resp))
    channel.on('line_cap_rounded', resp => broadcast('line_cap_rounded', resp))
    channel.on('line_joint_rounded', resp => broadcast('line_joint_rounded', resp))
    channel.on('line_show_points', resp => broadcast('line_show_points', resp))
    channel.on('line_show_distance', resp => broadcast('line_show_distance', resp))

    channel.on('video_url', resp => broadcast('video_url', resp))
    channel.on('video_coord1', resp => broadcast('video_coord1', resp))
    channel.on('video_coord2', resp => broadcast('video_coord2', resp))
    channel.on('video_coord3', resp => broadcast('video_coord3', resp))
    channel.on('video_coord4', resp => broadcast('video_coord4', resp))
    channel.on('video_min_zoom', resp => broadcast('video_min_zoom', resp))
    channel.on('video_max_zoom', resp => broadcast('video_max_zoom', resp))

    channel.on('text_settings', resp => broadcast('text_settings', resp))
    channel.on('video_settings', resp => broadcast('text_settings', resp))
    channel.on('point_settings', resp => broadcast('point_settings', resp))
    channel.on('line_settings', resp => broadcast('line_settings', resp))

    channel.on('update_polygon_opacity', resp => broadcast('update_polygon_opacity', resp))
    channel.on('update_polygon_color', resp => broadcast('update_polygon_color', resp))
    channel.on('update_polygon_border_width', resp => broadcast('update_polygon_border_width', resp))
    channel.on('update_polygon_border_opacity', resp => broadcast('update_polygon_border_opacity', resp))
    channel.on('update_polygon_border_color', resp => broadcast('update_polygon_border_color', resp))
    channel.on('update_polygon_pattern', resp => broadcast('update_polygon_pattern', resp))
    channel.on('update_polygon_pattern_scale', resp => broadcast('update_polygon_pattern_scale', resp))

    channel.on('update_point_icon', resp => broadcast('update_point_icon', resp))
    channel.on('update_point_size', resp => broadcast('update_point_size', resp))
    channel.on('update_point_angle', resp => broadcast('update_point_angle', resp))
    channel.on('update_point_min_pixels', resp => broadcast('update_point_min_pixels', resp))
    channel.on('update_point_max_pixels', resp => broadcast('update_point_max_pixels', resp))
    channel.on('update_point_tooltip_text', resp => broadcast('update_point_tooltip_text', resp))

    channel.on('update_line_color', resp => broadcast('update_line_color', resp))
    channel.on('update_line_opacity', resp => broadcast('update_line_opacity', resp))
    channel.on('update_line_width', resp => broadcast('update_line_width', resp))
    channel.on('update_line_cap_rounded', resp => broadcast('update_line_cap_rounded', resp))
    channel.on('update_line_joint_rounded', resp => broadcast('update_line_joint_rounded', resp))
    channel.on('update_line_show_points', resp => broadcast('update_line_show_points', resp))
    channel.on('update_line_show_distance', resp => broadcast('update_line_show_distance', resp))

    channel.on('update_video_url', resp => broadcast('update_video_url', resp))
    channel.on('update_video_coord1', resp => broadcast('update_video_coord1', resp))
    channel.on('update_video_coord2', resp => broadcast('update_video_coord2', resp))
    channel.on('update_video_coord3', resp => broadcast('update_video_coord3', resp))
    channel.on('update_video_coord4', resp => broadcast('update_video_coord4', resp))
    channel.on('update_video_min_zoom', resp => broadcast('update_video_min_zoom', resp))
    channel.on('update_video_max_zoom', resp => broadcast('update_video_max_zoom', resp))

    channel.on('update_text_color', resp => broadcast('update_text_color', resp))
    channel.on('update_text_opacity', resp => broadcast('update_text_opacity', resp))
    channel.on('update_text_text', resp => broadcast('update_text_text', resp))
    channel.on('update_text_size', resp => broadcast('update_text_size', resp))
    channel.on('update_text_anchor', resp => broadcast('update_text_anchor', resp))
    channel.on('update_text_alignment_baseline', resp => broadcast('update_text_alignment_baseline', resp))
    channel.on('update_text_angle', resp => broadcast('update_text_angle', resp))
    channel.on('update_text_font_family', resp => broadcast('update_text_font_family', resp))
    channel.on('update_text_font_weight', resp => broadcast('update_text_font_weight', resp))
    channel.on('update_text_max_width', resp => broadcast('update_text_max_width', resp))
    channel.on('update_text_word_break', resp => broadcast('update_text_word_break', resp))
    channel.on('update_text_background_padding_left', resp => broadcast('update_text_background_padding_left', resp))
    channel.on('update_text_background_padding_right', resp => broadcast('update_text_background_padding_right', resp))
    channel.on('update_text_background_padding_top', resp => broadcast('update_text_background_padding_top', resp))
    channel.on('update_text_background_padding_bottom', resp => broadcast('update_text_background_padding_bottom', resp))
    channel.on('update_text_background_color', resp => broadcast('update_text_background_color', resp))
    channel.on('update_text_background_opacity', resp => broadcast('update_text_background_opacity', resp))
    channel.on('update_text_border_color', resp => broadcast('update_text_border_color', resp))
    channel.on('update_text_border_opacity', resp => broadcast('update_text_border_opacity', resp))
    channel.on('update_text_border_width', resp => broadcast('update_text_border_width', resp))
    channel.on('update_text_outline_color', resp => broadcast('update_text_outline_color', resp))
    channel.on('update_text_outline_opacity', resp => broadcast('update_text_outline_opacity', resp))
    channel.on('update_text_outline_width', resp => broadcast('update_text_outline_width', resp))

    channel.on('finished_layer', resp => broadcast('finished_layer', resp))
    channel.on('layer_edit', resp => broadcast('user_layer_edit', resp))
    channel.on('delete_layer', resp => broadcast('remove_layer', resp.layer_id))

    channel.on('message_created', resp => broadcast('message_created', resp))
    channel.on('user_view_state', resp => broadcast('update_user_view_state', resp))

    return(channel)
  }
}

const chanel_push = (channel, type, payload) => {
  if (channel)
    channel.push(type, payload)
}

class Cont extends React.Component {
  constructor(props) {
    super(props)
    this.state = {channel: false, user_id: false, listners: []}
  }

  componentDidMount(){
    const listners = [
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode})},
      {type: "send_user_map_hover", fnc: ({detail}) => chanel_push(this.state.channel, "user_map_hover", detail)},
      {type: "send_user_map_drag_start", fnc: ({detail}) => chanel_push(this.state.channel, "user_map_drag_start", detail)},
      {type: "send_user_map_drag_end", fnc: ({detail}) => chanel_push(this.state.channel, "user_map_drag_end", detail)},
      {type: "send_user_map_drag", fnc: ({detail}) => chanel_push(this.state.channel, "user_map_drag", detail)},

      {type: "send_polygon_color", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_color", detail)},
      {type: "send_polygon_radius", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_radius", detail)},
      {type: "send_polygon_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_opacity", detail)},
      {type: "send_polygon_border_width", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_border_width", detail)},
      {type: "send_polygon_border_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_border_opacity", detail)},
      {type: "send_polygon_border_color", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_border_color", detail)},
      {type: "send_polygon_pattern", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_pattern", detail)},
      {type: "send_polygon_pattern_scale", fnc: ({detail}) => chanel_push(this.state.channel, "polygon_pattern_scale", detail)},

      {type: "send_text_color", fnc: ({detail}) => chanel_push(this.state.channel, "text_color", detail)},
      {type: "send_text_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "text_opacity", detail)},
      {type: "send_text_text", fnc: ({detail}) => chanel_push(this.state.channel, "text_text", detail)},
      {type: "send_text_size", fnc: ({detail}) => chanel_push(this.state.channel, "text_size", detail)},
      {type: "send_text_anchor", fnc: ({detail}) => chanel_push(this.state.channel, "text_anchor", detail)},
      {type: "send_text_alignment_baseline", fnc: ({detail}) => chanel_push(this.state.channel, "text_alignment_baseline", detail)},
      {type: "send_text_angle", fnc: ({detail}) => chanel_push(this.state.channel, "text_angle", detail)},
      {type: "send_text_font_family", fnc: ({detail}) => chanel_push(this.state.channel, "text_font_family", detail)},
      {type: "send_text_font_weight", fnc: ({detail}) => chanel_push(this.state.channel, "text_font_weight", detail)},
      {type: "send_text_max_width", fnc: ({detail}) => chanel_push(this.state.channel, "text_max_width", detail)},
      {type: "send_text_word_break", fnc: ({detail}) => chanel_push(this.state.channel, "text_word_break", detail)},
      {type: "send_text_background_padding_left", fnc: ({detail}) => chanel_push(this.state.channel, "text_background_padding_left", detail)},
      {type: "send_text_background_padding_right", fnc: ({detail}) => chanel_push(this.state.channel, "text_background_padding_right", detail)},
      {type: "send_text_background_padding_top", fnc: ({detail}) => chanel_push(this.state.channel, "text_background_padding_top", detail)},
      {type: "send_text_background_padding_bottom", fnc: ({detail}) => chanel_push(this.state.channel, "text_background_padding_bottom", detail)},
      {type: "send_text_background_color", fnc: ({detail}) => chanel_push(this.state.channel, "text_background_color", detail)},
      {type: "send_text_background_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "text_background_opacity", detail)},
      {type: "send_text_border_color", fnc: ({detail}) => chanel_push(this.state.channel, "text_border_color", detail)},
      {type: "send_text_border_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "text_border_opacity", detail)},
      {type: "send_text_border_width", fnc: ({detail}) => chanel_push(this.state.channel, "text_border_width", detail)},
      {type: "send_text_outline_color", fnc: ({detail}) => chanel_push(this.state.channel, "text_outline_color", detail)},
      {type: "send_text_outline_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "text_outline_opacity", detail)},
      {type: "send_text_outline_width", fnc: ({detail}) => chanel_push(this.state.channel, "text_outline_width", detail)},

      {type: "send_video_url", fnc: ({detail}) => chanel_push(this.state.channel, "video_url", detail)},
      {type: "send_video_coord1", fnc: ({detail}) => chanel_push(this.state.channel, "video_coord1", detail)},
      {type: "send_video_coord2", fnc: ({detail}) => chanel_push(this.state.channel, "video_coord2", detail)},
      {type: "send_video_coord3", fnc: ({detail}) => chanel_push(this.state.channel, "video_coord3", detail)},
      {type: "send_video_coord4", fnc: ({detail}) => chanel_push(this.state.channel, "video_coord4", detail)},
      {type: "send_video_min_zoom", fnc: ({detail}) => chanel_push(this.state.channel, "video_min_zoom", detail)},
      {type: "send_video_max_zoom", fnc: ({detail}) => chanel_push(this.state.channel, "video_max_zoom", detail)},

      {type: "send_line_color", fnc: ({detail}) => chanel_push(this.state.channel, "line_color", detail)},
      {type: "send_line_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "line_opacity", detail)},
      {type: "send_line_width", fnc: ({detail}) => chanel_push(this.state.channel, "line_width", detail)},
      {type: "send_line_cap_rounded", fnc: ({detail}) => chanel_push(this.state.channel, "line_cap_rounded", detail)},
      {type: "send_line_joint_rounded", fnc: ({detail}) => chanel_push(this.state.channel, "line_joint_rounded", detail)},
      {type: "send_line_show_points", fnc: ({detail}) => chanel_push(this.state.channel, "line_show_points", detail)},
      {type: "send_line_show_distance", fnc: ({detail}) => chanel_push(this.state.channel, "line_show_distance", detail)},

      {type: "send_point_icon", fnc: ({detail}) => chanel_push(this.state.channel, "point_icon", detail)},
      {type: "send_point_size", fnc: ({detail}) => chanel_push(this.state.channel, "point_size", detail)},
      {type: "send_point_angle", fnc: ({detail}) => chanel_push(this.state.channel, "point_angle", detail)},
      {type: "send_point_min_pixels", fnc: ({detail}) => chanel_push(this.state.channel, "point_min_pixels", detail)},
      {type: "send_point_max_pixels", fnc: ({detail}) => chanel_push(this.state.channel, "point_max_pixels", detail)},

      {type: "send_text_settings", fnc: ({detail}) => chanel_push(this.state.channel, "text_settings", detail)},
      {type: "send_line_settings", fnc: ({detail}) => chanel_push(this.state.channel, "line_settings", detail)},
      {type: "send_point_settings", fnc: ({detail}) => chanel_push(this.state.channel, "point_settings", detail)},

      {type: "send_update_polygon_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_opacity", detail)},
      {type: "send_update_polygon_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_color", detail)},
      {type: "send_update_polygon_border_width", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_border_width", detail)},
      {type: "send_update_polygon_border_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_border_opacity", detail)},
      {type: "send_update_polygon_border_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_border_color", detail)},
      {type: "send_update_polygon_pattern", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_pattern", detail)},
      {type: "send_update_polygon_pattern_scale", fnc: ({detail}) => chanel_push(this.state.channel, "update_polygon_pattern_scale", detail)},

      {type: "send_update_point_icon", fnc: ({detail}) => chanel_push(this.state.channel, "update_point_icon", detail)},
      {type: "send_update_point_size", fnc: ({detail}) => chanel_push(this.state.channel, "update_point_size", detail)},
      {type: "send_update_point_angle", fnc: ({detail}) => chanel_push(this.state.channel, "update_point_angle", detail)},
      {type: "send_update_point_min_pixels", fnc: ({detail}) => chanel_push(this.state.channel, "update_point_min_pixels", detail)},
      {type: "send_update_point_max_pixels", fnc: ({detail}) => chanel_push(this.state.channel, "update_point_max_pixels", detail)},

      {type: "send_update_line_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_color", detail)},
      {type: "send_update_line_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_opacity", detail)},
      {type: "send_update_line_width", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_width", detail)},
      {type: "send_update_line_cap_rounded", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_cap_rounded", detail)},
      {type: "send_update_line_joint_rounded", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_joint_rounded", detail)},
      {type: "send_update_line_show_points", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_show_points", detail)},
      {type: "send_update_line_show_distance", fnc: ({detail}) => chanel_push(this.state.channel, "update_line_show_distance", detail)},

      {type: "send_update_video_url", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_url", detail)},
      {type: "send_update_video_coord1", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_coord1", detail)},
      {type: "send_update_video_coord2", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_coord2", detail)},
      {type: "send_update_video_coord3", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_coord3", detail)},
      {type: "send_update_video_coord4", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_coord4", detail)},
      {type: "send_update_video_min_zoom", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_min_zoom", detail)},
      {type: "send_update_video_max_zoom", fnc: ({detail}) => chanel_push(this.state.channel, "update_video_max_zoom", detail)},

      {type: "send_update_text_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_color", detail)},
      {type: "send_update_text_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_opacity", detail)},
      {type: "send_update_text_text", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_text", detail)},
      {type: "send_update_text_size", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_size", detail)},
      {type: "send_update_text_anchor", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_anchor", detail)},
      {type: "send_update_text_alignment_baseline", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_alignment_baseline", detail)},
      {type: "send_update_text_angle", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_angle", detail)},
      {type: "send_update_text_font_family", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_font_family", detail)},
      {type: "send_update_text_font_weight", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_font_weight", detail)},
      {type: "send_update_text_max_width", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_max_width", detail)},
      {type: "send_update_text_word_break", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_word_break", detail)},
      {type: "send_update_text_background_padding_left", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_background_padding_left", detail)},
      {type: "send_update_text_background_padding_right", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_background_padding_right", detail)},
      {type: "send_update_text_background_padding_top", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_background_padding_top", detail)},
      {type: "send_update_text_background_padding_bottom", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_background_padding_bottom", detail)},
      {type: "send_update_text_background_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_background_color", detail)},
      {type: "send_update_text_background_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_background_opacity", detail)},
      {type: "send_update_text_border_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_border_color", detail)},
      {type: "send_update_text_border_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_border_opacity", detail)},
      {type: "send_update_text_border_width", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_border_width", detail)},
      {type: "send_update_text_outline_color", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_outline_color", detail)},
      {type: "send_update_text_outline_opacity", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_outline_opacity", detail)},
      {type: "send_update_text_outline_width", fnc: ({detail}) => chanel_push(this.state.channel, "update_text_outline_width", detail)},

      {type: "send_layer_edit", fnc: ({detail}) => chanel_push(this.state.channel, "layer_edit", detail)},
      {type: "user_view_state", fnc: ({detail}) => chanel_push(this.state.channel, "user_view_state", detail)},
      {type: "send_map_tile_links", fnc: ({detail}) => chanel_push(this.state.channel, "map_tile_links", detail)},

      {type: "current_user", fnc: ({detail}) => {
        this.setState({user_id: detail.id, channel: reload_if_no_token(detail.id, detail.access_token)})
      }},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  render() {
    return (
      <div
        onMouseMove={e => broadcast("containter_onMouseMove", e)}
      >
        <MyMap user_id={this.state.user_id} />
        <Toolbar user_id={this.state.user_id} />
        <PolygonTool user_id={this.state.user_id} />
        <LineTool user_id={this.state.user_id} />
        <TextTool user_id={this.state.user_id} />
        <PointTool user_id={this.state.user_id} />
        <TilesTool user_id={this.state.user_id} />
        <VideoTool user_id={this.state.user_id} />
        <Chat user_id={this.state.user_id} />
        <Notifications user_id={this.state.user_id} />
        <Auth user_id={this.state.user_id} />
        <UserLayers user_id={this.state.user_id} />
        <LayerEditor user_id={this.state.user_id} />
      </div>
    )
  }
}

export default Cont;
